import { UseFormReturn } from 'react-hook-form'

import { ConvertStablesFormFields } from '../../types'
import { ConvertStablesFormSchema } from './schema'
import { TokenWithBalance } from '@/domain/common/types'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export interface GetConvertStablesFormFieldsParams {
  form: UseFormReturn<ConvertStablesFormSchema>
  tokenRepository: TokenRepository
  psmStables: TokenSymbol[]
}
export function getConvertStablesFormFields({
  form,
  tokenRepository,
  psmStables,
}: GetConvertStablesFormFieldsParams): ConvertStablesFormFields {
  const { from, to } = form.watch()
  const selectedAssetIn = tokenRepository.findOneBySymbol(from)
  const selectedAssetOut = tokenRepository.findOneBySymbol(to)

  const allStablesWithBalance: TokenWithBalance[] = psmStables
    .map((symbol) => {
      const token = tokenRepository.findBySymbol(symbol)
      if (!token) return undefined
      return { token, balance: tokenRepository.findOneBalanceOrZero(symbol) }
    })
    .filter(Boolean)
  const assetInOptions = allStablesWithBalance.filter(({ token }) => token.symbol !== selectedAssetIn.symbol)
  const assetOutOptions = allStablesWithBalance.filter(
    ({ token }) => token.symbol !== selectedAssetOut.symbol && token.symbol !== selectedAssetIn.symbol,
  )

  function changeAssetIn(newSymbol: TokenSymbol): void {
    if (newSymbol === to) {
      form.setValue('to', from)
    }
    form.setValue('from', newSymbol)
    form.setValue('amount', '')
    form.setValue('isMaxSelected', false)
    form.clearErrors()
  }

  function changeAssetOut(newSymbol: TokenSymbol): void {
    form.setValue('to', newSymbol)
    form.clearErrors()
  }

  return {
    selectedAssetIn,
    selectedAssetInBalance: tokenRepository.findOneBalanceOrZero(selectedAssetIn.symbol),
    selectedAssetOut,
    assetInOptions,
    assetOutOptions,
    changeAssetIn,
    changeAssetOut,
    maxSelectedFieldName: 'isMaxSelected',
  }
}
